import axios from 'axios';
import { ADDITIONAL_CONTENT_API_PATH } from 'constants/api';
import { AdditionalContentCreateInterface, ContentInterface } from 'content/type';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';

class AdditionalContentService extends ApiService<AdditionalContentCreateInterface> {
  public async fetchAdditionalContent(
    queryParams?: URLSearchParams
  ): Promise<FetchResult<ContentInterface>> {
    const response = await axios.get(this.constructUrl(), { params: queryParams });
    return response.data;
  }

  async createAdditionalContentLink(
    originId: number,
    originType: string,
    contentIds: number[],
    contentType: string
  ): Promise<void> {
    await this.create({
      origin_id: originId,
      origin_type: originType,
      content_ids: contentIds,
      content_type: contentType,
    });
  }

  async deleteAdditionalContentLink(originId: number, contentIds: number[]): Promise<void> {
    await axios.delete(this.constructUrl(), {
      data: {
        origin_id: originId,
        content_ids: contentIds,
      },
    });
  }
}

export const additionalContentService = new AdditionalContentService(ADDITIONAL_CONTENT_API_PATH);
